import React, { useRef, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import noImage from '../../../assets/images/no-image.png';
import ImgDropzone from '../../../Components/ImgDropzone/ImgDropzone';
import { imageUrl } from '../../../Components/helper';

function SignatureModal({ onOpen, onConfirm, toggle, signatureData }) {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    signData: { ...signatureData },
    imageModal: false,
  });

  const { signData, imageModal } = state;
  const childRef = useRef();
  const handleFont = (e, i) => {
    const object = cloneDeep(signData);
    object.fontFamily = e;
    object.fontStyles.map((fontObj) => ({
      ...fontObj,
      isActive: false,
    }));
    object.fontStyles[i].isActive = true;
    setState((prevState) => ({
      ...prevState,
      signData: object,
    }));
  };

  const handleInput = (e) => {
    const object = cloneDeep(signData);
    object.placeholder = e.target.value;

    setState((prevState) => ({
      ...prevState,
      signData: object,
    }));
  };

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();
      const { imageRes } = croppedFileUrl;

      if (imageRes?.length) {
        const object = cloneDeep(signData);
        object.digitalSignPath = imageRes;

        setState((prevState) => ({
          ...prevState,
          imageModal: false,
          signData: object,
        }));
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        imageModal: false,
      }));
    }
  };

  const handleUploadImage = () => {
    setState((prevState) => ({
      ...prevState,
      imageModal: true,
    }));
  };

  const handleRemoveImage = () => {
    const object = cloneDeep(signData);

    object.digitalSignPath = '';
    setState((prevState) => ({
      ...prevState,
      signData: object,
    }));
  };

  const getImage = (imagePath) => {
    let logo = null;
    if (imagePath?.includes('base64')) {
      logo = imagePath;
    } else {
      logo = `${imageUrl}/${imagePath}`;
    }
    return logo;
  };

  return (
    <>
      <Modal show={onOpen} backdrop="static" className="custom-modal" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title id="contained-modal-title-vcenter">
              <span>{t('CUSTOM_MODULE.UPDTAE_SIGNATURE')}</span>
            </Modal.Title>
            <button type="button" onClick={toggle} className="btn p-0">
              <span className="sr-only">{t('DEVLOPMENT_ORDER.CUSTOM_MODULE.SIGNATURE_MODAL.CLOSE')}</span>
              <span className="icon-close cursor-pointer text-dark text-decoration-none" />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="custom-tabs">
              <Tabs defaultActiveKey="type" id="uncontrolled-tab-example">
                <Tab eventKey="type" title={t('TAKING_DATES.TYPE')}>
                  <input type="text" value={signData?.placeholder} onChange={handleInput} className="form-control text-bordered mb-2" />
                  <div className="d-flex flex-wrap">
                    {signData?.fontStyles?.map((element, index) => {
                      return (
                        <div className="sign-container" key={element}>
                          {signData?.placeholder && (
                            <button
                              type="button"
                              className={signData?.fontFamily === element?.font ? 'active' : ''}
                              onClick={() => handleFont(element?.font, index)}
                              style={{ fontFamily: element?.font }}
                            >
                              {signData?.placeholder}
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Tab>
                <Tab eventKey="upload" title={t('TAKING_DATES.UPLOADS')}>
                  <div className="text-center p-3">
                    <div className="image-upload-container">
                      <figure>
                        <img className="img-thumb" src={getImage(signData?.digitalSignPath) || noImage} alt="" />
                      </figure>
                      <div className="btn-container">
                        <button type="button" onClick={() => handleUploadImage()} className="btn">
                          <span className="sr-only">{t('DEVLOPMENT_ORDER.CUSTOM_MODULE.SIGNATURE_MODAL.UPLOAD')}</span>
                          <i className="icon-upload mr-2" />
                        </button>
                        {signData?.digitalSignPath !== '' && (
                          <button type="button" onClick={() => handleRemoveImage()} className="btn">
                            <span className="sr-only">{t('DEVLOPMENT_ORDER.CUSTOM_MODULE.SIGNATURE_MODAL.DELETE')}</span>
                            <i className="icon-delete mr-2" />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
            <div className="modal-buttons mt-5 d-flex justify-content-between">
              <button type="button" onClick={toggle} className="btn btn-default">
                {t('CUSTOM_MODULE.NO')}
              </button>
              <button type="button" onClick={() => onConfirm(signData)} disabled={signData?.label?.trim() === ''} className="btn btn-default">
                {t('CUSTOM_MODULE.YES')}
              </button>
            </div>
          </>
        </Modal.Body>
      </Modal>
      {imageModal && (
        <Modal className="common-custom-modal modal-large" show={imageModal} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('CUSTOM_MODULE.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleImageUpload('close')} className="icon-close cursor-pointer text-dark text-decoration-none" />
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body">
              <ImgDropzone
                ref={childRef}
                onSubmit={handleImageUpload}
                acceptedFileExtenstion=".jpeg,.png,.jpg"
                title={t('TAKING_DATES.SIGNATURE')}
                image={getImage(signData?.digitalSignPath)}
                isEditMode={false}
                cropSize="FREE"
                fromCustomModule
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default SignatureModal;
